import { useOnboardingTutorialContext } from "./onboardingTutorialContext";
import { useGTMEvent } from "../../GoogleTagManager/googleTagManagerHooks";
import { useCallback } from "react";
import OnboardingTutorialMainWrapper from "./components/OnboardingTutorialMainWrapper/OnboardingTutorialMainWrapper";
import {
    OnboardingTutorialSelectOrderSideButtonsContainerStyled,
    OnboardingTutorialSelectOrderSideButtonStyled,
} from "./styled/OnboardingTutorialSelectOrderSide";
import { ONBOARDING_TUTORIAL_IMAGES } from "./onboardingTutorialConstants";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

export const OnboardingTutorialSelectOrderSide = () => {
    const {getLangPath} = useLangContext();
    const {handleStepForward} = useOnboardingTutorialContext();

    const {pushGtmEvent} = useGTMEvent({module: 'OnboardingTutorialSelectOrderSide'});

    const handleSellButtonClick = useCallback(() => {
        pushGtmEvent({event: 'onboarding_click', button: 'Sell'});
        handleStepForward();
    }, [handleStepForward, pushGtmEvent]);

    return <OnboardingTutorialMainWrapper backgroundImg={ONBOARDING_TUTORIAL_IMAGES.MAIN_SCREEN_BG}>
        <p className="text-center" dangerouslySetInnerHTML={{__html: getLangPath('onboarding.tap_sell')}}/>
        <OnboardingTutorialSelectOrderSideButtonsContainerStyled>
            <OnboardingTutorialSelectOrderSideButtonStyled className="sell flex-fill" onClick={handleSellButtonClick}>
                {getLangPath('onboarding.sell_button')}
            </OnboardingTutorialSelectOrderSideButtonStyled>
            <OnboardingTutorialSelectOrderSideButtonStyled className="flex-fill">
                {getLangPath('onboarding.buy_button')}
            </OnboardingTutorialSelectOrderSideButtonStyled>
        </OnboardingTutorialSelectOrderSideButtonsContainerStyled>
    </OnboardingTutorialMainWrapper>

}